<template>
<v-touch 
  v-on:swipeleft="isEnd && isNotSingleSlider && toNext()" 
  v-on:swiperight="isEnd && isNotSingleSlider && toPrev()"
  :swipe-options="{ direction: 'horizontal' }">
  <div class="cx-slider"
    ref="slideContainer"
    dir="ltr"
    tabindex="0"
    @keydown.left="toPrev"
    @keydown.right="toNext"
    @mouseenter="loop && isNotSingleSlider && stopLoop()"
    @mouseleave="loop && isNotSingleSlider && restartLoop()"
    @touchstart="loop && isNotSingleSlider && stopLoop()"
    @touchend="loop && isNotSingleSlider && restartLoop()"
    @touchcancel="loop && isNotSingleSlider && restartLoop()"
  >
    <!-- <div class="cx-slider__mask"></div> -->

    <div class="cx-slider__nav" v-if="numOfSlide > 1" v-show="isNotSingleSlider">
      <div class="cx-slider__pager">
        <template v-for="(g, idx) in galleryToShow.slice(1, numOfSlide - 1)">
          <a :key="g.path + `-${idx}`" href="#" role="button" class="cx-link"
            :aria-label="g.title"
            :class="{'-active': checkPagerActive(idx)}"
            style="position: relative; font-size: 10px;"
            :style="isPaused && checkPagerActive(idx) ? 'background-color: transparent' : checkPagerActive(idx) ? 'background-color: #FFFFFF' : ''"
            @click.prevent="handlePagerClick(idx)"
          >
            <template v-if="checkPagerActive(idx)">
              <template v-if="isPaused">
                <i class="fad fa-play-circle" style="position: absolute; top: 0; left: 0; --fa-primary-color: #000000; --fa-primary-opacity: 1; --fa-secondary-color: #ffffff; --fa-secondary-opacity: 1;"></i>
              </template>
              <template v-else>
                <i class="fad fa-pause-circle" style="position: absolute; top: 0; left: 0; --fa-primary-color: #000000; --fa-primary-opacity: 1; --fa-secondary-color: #ffffff; --fa-secondary-opacity: 1;"></i>
              </template>
            </template>
          </a>
        </template>
      </div>
      <a href="#" role="button" :aria-label="$t('common.previousPage')" class="cx-link cx-slider__nav_control" @click.prevent="isEnd && toPrev()">
        <span class="cx-link__icon">
          <i class="far fa-2x fa-chevron-left"></i>
        </span>
      </a>
      <a href="#" role="button" :aria-label="$t('common.nextPage')" class="cx-link cx-slider__nav_control" @click.prevent="isEnd && toNext()">
        <span class="cx-link__icon">
          <i class="far fa-2x fa-chevron-right"></i>
        </span>
      </a>
    </div>
    <div ref="slide"
      class="cx-slider__slide" :data-activeslide="activeSlide + 1"
      :style="`${removeTransition ? 'transition: none;': ''}
        ${ isMouseDown && positionToMove != null
          ? `transform: translateX(calc((-${getBrowserRounding(activeSlide * actulWidth)}px + ${positionToMove}px)));
            transition: none;`
          : `transform: translateX(calc((-${getBrowserRounding(activeSlide * actulWidth)}px)));`}`"
      @touchstart="(e) => isNotSingleSlider && mousedown(e)"
      @mousedown="(e) => isNotSingleSlider && mousedown(e)"
      @mouseup="(e) => isNotSingleSlider && mouseup(e)"
      @mouseleave="(e) => isNotSingleSlider && mouseup(e)"
      @touchend="(e) => isNotSingleSlider && mouseup(e)"
      @touchcancel="(e) => isNotSingleSlider && mouseup(e)"
      @mousemove="(e) => isNotSingleSlider && mousemove(e)"
      @touchmove="(e) => isNotSingleSlider && mousemove(e)"
    >
      <template v-for="(g, idx) in galleryToShow">
        <div :key="g.path +
                (idx == 0 || idx == numOfSlide - 1 ? `-tmp-${idx}`  : `-${idx}`)"
          class="cx-slider__item" 
        >
          <!-- <component :is="(g.link || g.to) ? 'a': 'span' " :href="g.link || g.to || ''" 
            @click="(e) => handleClick(e, g.link, g.to)" 
            rel="noopener noreferrer" target="_blank"
          > -->
          <component
            :aria-label="idx ===1 ? g.title :''"
            :aria-hidden="idx ===1 ? false : true"
            :is="''"
            v-bind="linkProps(g.link || g.to || null)"
          >
            <div class="cx-media--cover">
              <cx-img v-if="!g.video || blackAndWhite || isMobile"
                tag='div'
                :imgSrc="`${g.path}`"
                :key="g.path + `-${idx}`"
                lazyLoad
                class="cx-media__img m-hero__slide" 
              ></cx-img>

              <div v-else
                :style="sliderStyle"
                class="cx-media__video m-hero__slide m-hero__video" 
                :class="sliderClass">
                <video :class="{ 'bnw-gray': blackAndWhite_state }" :data-slide-idx="idx" :muted="defaultMuted" :src="g.video"></video>
              </div>

              <div class="cx-media__caption cx-t02" v-if="g.caption">
                {{g.caption}}
              </div>

              <span v-if="expand && (!g.video || blackAndWhite || isMobile)" 
                class="cx-media__expand"
                @click="expandImage(g.path)"
              ><i class="fal fa-2x fa-expand-arrows"></i></span>
            </div>
          </component>
        </div>       
      </template>
    </div>

    <template v-if="pauseControl && !isMobile">
      <div class="cx-slider__pause_control">
        <button class="pause_control__toggle_play" :title="paused ? $t('action.play') : $t('action.pause')" @click="toggleVideoPlay(true)">
          <i v-show="paused" class="fas fa-play"></i>
          <i v-show="!paused" class="fas fa-pause"></i>
          <span class="sr-only">{{ paused ? $t('action.play') : $t('action.pause') }}</span>
        </button>
      </div>
    </template>
    <template v-if="volumeControl && !isMobile">
      <div class="cx-slider__volume_control">
        <button class="volume_control__toggle_mute" :title="muted ? $t('action.unmute') : $t('action.mute')" @click="toggleVideoVolume(true)">
          <i v-show="muted" class="fas fa-volume-mute"></i>
          <i v-show="!muted" class="fas fa-volume"></i>
          <span class="sr-only">{{ muted ? $t('action.unmute') : $t('action.mute') }}</span>
        </button>
      </div>
    </template>
  </div>
</v-touch>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'cx-slider',
  uit() {
    return [
      ['action', ['pause', 'play', 'mute', 'unmute']],
      ['common', ['nextPage', 'previousPage']]
    ]
  },
  props: {
    pauseControl: {
      type: Boolean,
      default: false
    },
    volumeControl: {
      type: Boolean,
      default: false
    },
    gallery: {
      type: Array,
      default: () => []
    },
    loop: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 3000
    },
    expand: {
      type: Boolean,
      default: false
    },
    sliderStyle: {
      type: Object,
      default: () => ({})
    },
    sliderClass: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isPaused: false,
      observer: null,
      isIntersecting: null,
      intersectingThresholdTimer: null,
      defaultMuted: true,
      paused: false,
      muted: true,
      videoVolume: 0,
      activeSlide: 1,
      timer: null,
      isMouseDown: false,
      initX: 0,
      positionToMove: null,
      removeTransition: true,
      isMouseMove: false,
      actulWidth: 0,
      widthOffset: 0,
      playingVideo: false,
      moving: false,
      movingCounter: null
    }
  },
  mounted() {
    this.initSlider();
    window.addEventListener('resize', this.handleWindowResize);

    if (this.$refs
      && this.$refs.slideContainer
      && "IntersectionObserver" in window
    ) {
      this.observer = new IntersectionObserver((entries, observer) => {
        let {isIntersecting, intersectionRatio} = entries[0];
        this.intersectingThresholdTimer && clearTimeout(this.intersectingThresholdTimer);
        this.intersectingThresholdTimer = setTimeout(() => {
          this.isIntersecting = isIntersecting;
        }, 500);
      }, {
        root: null, //document.querySelector('#app'),
        // rootMargin: `${100}px`,
        // threshold: 0
      });
      this.observer.observe(this.$refs.slideContainer);
    }
  },
  beforeDestroy() {
    this.stopLoop();
    window.removeEventListener('resize', this.handleWindowResize);

    this.observer && this.observer.unobserve(this.$refs.slideContainer);
  },
  computed: {
    ...mapState({
      isMobile: state => state.ui.isMobile,
      blackAndWhite_state: state => state.ui.blackAndWhite,
    }),
    blackAndWhite() {
      return false; // bnw do not effect video
    },
    isNotSingleSlider() {
      return this.numOfSlide > 3;
    },
    isEnd() {
      return this.activeSlide != this.numOfSlide - 1 && this.activeSlide != 0;
    },
    numOfSlide: function() {
      return this.galleryToShow.length;
    },
    galleryToShow() {
      return this.gallery.length > 0 
      ? [this.gallery[this.gallery.length - 1]]
          .concat(this.gallery)
          .concat([this.gallery[0]])
      : [];
    },
  },
  methods: {
    initSlider() {
      !!this.loop && this.restartLoop();
      !this.isNotSingleSlider && this.stopLoop();
      this.handleWindowResize();
      this.checkActiveSlide();
    },
    expandImage(src) {
      const modalID = 'tmp-' + (new Date()).getTime();
      const phId = 'ph-' + modalID;
      const imgSrc = this.parseImg(src);
      ModalManager.create(
        modalID,
        `<div style="display: grid; place-items: center;">
          <div id="${phId}" style="grid-area: 1/1; position: relative; transition: opacity 0.5s ease;">
            <img src="/static/images/common/default.jpg" style="max-width: 100%; display: block;" alt=""/>
            <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,0.6); display: flex; align-items: center; justify-content: center;">
              <i class="fas fa-circle-notch fa-spin fa-3x" style="color: #999;"></i>
            </div>
          </div>
          <img style="grid-area: 1/1; max-width: 100%; opacity: 0; transition: opacity 0.5s ease;" src="${imgSrc}" alt=""
            onload="this.style.opacity='1'; var p=document.getElementById('${phId}'); if(p){ p.style.opacity='0'; setTimeout(function(){ p.style.display='none'; }, 500); }"
          />
        </div>`
      ).onClose(function() {
        ModalManager.remove(modalID);
      }).mount().open()
    },
    handleClick(e, link, to='') {
      if (this.isMouseMove || !link) {
        e.preventDefault();
        !link && to && this.$router.push(to);
      }
    },
    mousedown(e) {
      this.isMouseDown = true;
      this.isMouseMove = false;
      let x = e.clientX;
      if (e.touches) {
        x = [].map.call(e.touches, t => t.pageX)[0] || 0;
      }
      this.initX = x;
    },
    mouseup() {
      this.isMouseDown = false;
      this.positionToMove = null;
    },
    mousemove(e) {
      if (!this.isMouseDown) return;
      this.isMouseMove = true;
      let moveX = e.clientX;
      if (e.touches) {
        moveX = [].map.call(e.touches, t => t.pageX)[0] || 0;
      }
      this.positionToMove = moveX - this.initX;
    },
    startLoop: function() {
      if (this.timer !== null) return;
      this.timer = this.createLoop();
    },
    stopLoop: function() {
      if (this.timer == null) return;
      clearInterval(this.timer);
      this.timer = null;
    },
    restartLoop: function() {
      if (this.isPaused) return;
      if (this.playingVideo) return ;
      this.stopLoop();
      this.startLoop();
    },
    createLoop: function() {
      return setInterval(this.toNext, this.duration || 3000);
    },

    checkPagerActive(idx) {
      return (this.activeSlide == idx + 1) || (this.activeSlide == this.numOfSlide - 1 && idx == 0) || (this.activeSlide == 0 && idx == this.numOfSlide - 3)
    },
    handlePagerClick(idx) {
      if (!this.loop) {
        this.toSlide(idx + 1);
        return ;
      }
      const isActive = this.checkPagerActive(idx);
      if (isActive) {
        if (this.isPaused) {
          this.isPaused = false;
          this.startLoop();
        } else {
          this.isPaused = true;
          this.stopLoop();
        }
      } else {
        this.toSlide(idx + 1);
      }
    },

    toPrev: function() {
      let tmpActiveSlide = this.activeSlide - 1;

      this.activeSlide = tmpActiveSlide;
      this.startMoving();
      this.removeTransition = false;
      this.positionToMove = null;
      const isEnd = tmpActiveSlide == 0;
      isEnd && setTimeout(() => {
        this.removeTransition = true;
        this.activeSlide = this.numOfSlide - 2;
      }, 500)
      this.$emit('slideChange', this.activeSlide);
    },
    toNext: function() {
      let tmpActiveSlide = this.activeSlide + 1;

      this.activeSlide = tmpActiveSlide; 
      this.startMoving();
      this.removeTransition = false;
      this.positionToMove = null;
      const isEnd = tmpActiveSlide == this.numOfSlide - 1;
      isEnd && setTimeout(() => {
        this.removeTransition = true;
        this.activeSlide = 1;
      }, 500)
      this.$emit('slideChange', this.activeSlide);
    },
    startMoving: function() {
      this.moving = true;
      this.movingCounter && clearTimeout(this.movingCounter);
      this.movingCounter = setTimeout(() => {
        this.moving = false;
      }, 500)
    },
    toSlide: function(idx) {
      this.activeSlide = idx;
      this.startMoving();
      this.$emit('slideChange', this.activeSlide);
    },
    handleWindowResize: function() {
      this.actulWidth = parseFloat(getComputedStyle(this.$refs.slide).width.replace('px', ''), 10);
      this.$nextTick(() => {
        this.updateWidthOffset();
      })
    },
    updateWidthOffset: function() {
      const renderWidth = this.$refs.slide.clientWidth;
      this.widthOffset = this.actulWidth - renderWidth;
    },
    getBrowserRounding: function(num) {
      if (!this.$refs || !this.$refs.slide) {
        return num;
      }
      
      return /(chrome|safari)/i.test(window.navigator.userAgent)
        ? Math.ceil(num)
        : Math.round(num)
    },
    checkActiveSlide: function() {
      if (this.isMobile) {
        this.muted = true;
        this.toggleVideoVolume();
      }
      this.$refs.slide 
        && !this.blackAndWhite
        && !this.isMobile 
        && this.galleryToShow.forEach((slide, idx) => {
          if (!slide.video || idx == this.activeSlide) return ;
          let v = this.$refs.slide.querySelector(`video[data-slide-idx="${idx}"]`);
          v.pause();
          v.currentTime = 0;
        })

      if (this.loop 
        && this.activeSlide > 0 
        && this.activeSlide < this.numOfSlide - 1
        && !this.isMobile
        && this.galleryToShow[this.activeSlide].video
        && this.$refs.slide
      ) {
        let v =this.$refs.slide.querySelector(`video[data-slide-idx="${this.activeSlide}"]`);
        if (!v && !this.isNotSingleSlider) return;
        this.playingVideo = true;
        this.stopLoop();
        if (!this.paused) {
          v.play();
        }
        v.currentTime = 0;
        this.toggleVideoVolume();
        const videoEnded = (actIdx) => () => {
          if (!this.isNotSingleSlider || this.isPaused) {
            if (!this.paused) {
              v.play();
            }
            return;
          }

          this.playingVideo = false;
          if (actIdx != this.activeSlide) return;
          this.toNext();
          this.restartLoop();
        }

        v.addEventListener('ended', videoEnded(this.activeSlide), { once: this.isNotSingleSlider });
      } else {
        this.playingVideo = false;
      }
    },
    toggleVideoPlay(isClick = false) {
      if (!this.pauseControl) {
        return;
      }
      // if (this.isMobile) {
      //   return;
      // }
      const video = this.$refs.slide.querySelector(`video[data-slide-idx="${this.activeSlide}"]`);
      if (video) {
        if (this.paused) {
          video.play();
          this.paused = video.paused;
        } else {
          video.pause();
          this.paused = video.paused;
        }
      }
    },
    toggleVideoVolume(isClick = false) {
      if (!this.volumeControl) {
        return;
      }
      // if (this.isMobile) {
      //   return;
      // }
      const videos = [...this.$refs.slide.querySelectorAll(`video[data-slide-idx]`)];
      // initial unmute all videos on user click
      if (isClick) {
        this.muted = !this.muted;
        if (this.defaultMuted) {
          videos.forEach(v => (v.volume = 0));
          this.videoVolume = 0;
          this.defaultMuted = false;
        }
      }
      if (this.defaultMuted) {
        return;
      }

      // immediately mute all videos
      const fadeOut = (v) => {
        clearTimeout(v._fadeInTimer);
        v._fadeOutTimer = setTimeout(() => {
          this.videoVolume -= 0.01;
          if (this.videoVolume <= 0) {
            this.videoVolume = 0;
          }
          v.volume = this.videoVolume;
          if (v.volume > 0) {
            fadeOut(v);
          } else {
            clearTimeout(v._fadeOutTimer);
          }
        }, 10);
      };
      // gradually increase active video volume
      const fadeIn = (v) => {
        if (this.muted) {
          clearTimeout(v._fadeInTimer);
          return;
        }
        clearTimeout(v._fadeOutTimer);
        v._fadeInTimer = setTimeout(() => {
          if (v.volume >= 0.00 && v.volume <= 0.25) {
            this.videoVolume += 0.006;
          }
          if (v.volume >= 0.25 && v.volume <= 0.50) {
            this.videoVolume += 0.007;
          }
          if (v.volume >= 0.50 && v.volume <= 0.75) {
            this.videoVolume += 0.008;
          }
          if (v.volume >= 0.75 && v.volume <= 1.00) {
            this.videoVolume += 0.009;
          }
          if (this.videoVolume >= 1) {
            this.videoVolume = 1;
          }
          v.volume = this.videoVolume;
          if (v.volume < 1) {
            fadeIn(v);
          } else {
            clearTimeout(v._fadeInTimer);
          }
        }, 10);
      };

      videos.forEach(v => {
        const isActive = +v.dataset.slideIdx === this.activeSlide;
        if (this.muted || !this.isIntersecting) {
          return fadeOut(v);
        }
        return isActive ? fadeIn(v) : fadeOut(v);
      });
    },
  },
  watch: {
    "isMobile": function() {
      this.$nextTick(this.checkActiveSlide);
    },
    "isIntersecting": function() {
      this.toggleVideoVolume();
    },
    "gallery": {
      deep: true,
      handler: function(val) {
        this.activeSlide = 1;
        this.$nextTick(this.initSlider);
      }
    },
    "activeSlide": function() {
      this.checkActiveSlide();
      if (this.actulWidth != 0) {
        this.updateWidthOffset();
      } else {
        this.widthOffset = 0;
      }
    },
    positionToMove: function(val) {
      if (!val) {
        this.startMoving();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cx-slider__mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: none;
}
.cx-slider__mask::before {
  content: '';
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0;
  bottom: 81.48%;
  background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
  opacity: 0.3;
}
.cx-slider__mask::after {
  content: '';
  position: absolute;
  left: 0%;
  right: 0%;
  top: 81.48%;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  opacity: 0.3;
}

.cx-slider:not(.-bar) .cx-slider__pager .cx-link,
.cx-slider:not(.-bar) .cx-slider__pager .cx-link--stack,
.cx-slider:not(.-bar) .cx-slider__pager .cx-btn--stack {
  width: 10px;
  height: 10px;
  background-color: transparent;
  border: 2px solid #FFFFFF;
  opacity: 1;
  // box-shadow: none;
}

// https://3.basecamp.com/3633946/buckets/6317965/todos/5740482807#__recording_6115323173
.cx-slider__pager .cx-link,
.cx-slider__pager .cx-link--stack,
.cx-slider__pager .cx-btn--stack {
  box-shadow: none !important;
  text-shadow: none !important;
}
.cx-slider__nav .cx-link,
.cx-slider__nav .cx-link--stack,
.cx-slider__nav .cx-btn--stack {
  box-shadow: none !important;
  text-shadow: none !important;
}

.cx-slider:not(.-bar) .cx-slider__pager .cx-link.-active,
.cx-slider:not(.-bar) .cx-slider__pager .cx-link--stack.-active,
.cx-slider:not(.-bar) .cx-slider__pager .cx-btn--stack.-active {
  border: 0px;
}

.cx-slider:not(.-bar) .cx-slider__pager .cx-link {
	background: none !important;
	border: 0 !important;
	width: 1rem !important;
	height: 1rem !important;
	font-size: 1rem !important;
	margin: 0 .2rem;
}
.cx-slider:not(.-bar) .cx-slider__pager .cx-link::before {
	content: "\f111";
	font-family: "Font Awesome 6 Pro";
	font-weight: 400;
}
.cx-slider:not(.-bar) .cx-slider__pager .cx-link.-active::before {
	font-weight: 900;
}

.cx-media__expand i,
.cx-slider__nav_control i,
.cx-slider__pause_control i,
.cx-slider__volume_control i,
.cx-slider__next i,
.cx-slider__prev i,
.cx-slider__pager .cx-link:before {
  text-shadow: 0 0 2px #000, 0 0 2px #000, 0 0 2px #000, 0 0 2px #000, 0 0 2px #000, 0 0 2px #000, 0 0 2px #000, 0 0 .1em #000;
}
.cx-media__expand {
	opacity: 1;
}

.cx-slider__nav_control {
  opacity: 1;
  // text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);

  i.far {
    color: #FFFFFF;
  }
}

.cx-slider__pause_control {
  right: 4rem;
}
.cx-slider__volume_control {
  right: 0.5rem;
}

.cx-slider__pause_control,
.cx-slider__volume_control {
  position: absolute;
  z-index: 2;
  bottom: 1rem;

  button.pause_control__toggle_play,
  button.volume_control__toggle_mute {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 3em;
    height: 3em;
    padding: 0;
    border: 0;
    background: transparent;
    color: #FFFFFF;
    cursor: pointer;
    // outline: none;
    // opacity: .7;
    transition: .2s ease-in-out;
    // text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);

    i.fas {
      font-size: 2em;
    }
  }

  button.volume_control__toggle_mute {
    justify-content: flex-start;
  }
  button.pause_control__toggle_play:hover,
  button.volume_control__toggle_mute:hover {
    opacity: 1;
    // text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
  }
}
</style>
